import { rem } from 'polished';
import * as React from 'react';
import styled, { css } from 'styled-components';
import { itemIsSkvelko } from '../../../utilities';
import { __ } from '@bart.sk-eshop/react-i18n';

const Sticker = css`
  text-align: center;
  color: ${({ theme }) => theme.color.white};
  border-radius: 50%;
  width: ${rem(60)};
  height: ${rem(60)};
  position: absolute;
  top: ${rem(10)};
  right: ${rem(10)};
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;

  ${({ theme }) => theme.media('xs')} {
    width: ${rem(45)};
    height: ${rem(45)};
    top: ${rem(5)};
    right: ${rem(5)};
  }
`;

const NotSkvelkoTextWrapper = styled.div`
  text-transform: uppercase;
  font-weight: 800;
  font-size: ${rem(14)};
  line-height: ${rem(15)};
`;

const Wrapper = styled.div`
  ${Sticker};
  background: ${({ theme }) => theme.color.primary};
`;

const SkvelkoTextWrapper = styled.div``;

const SvelkoTopTextWrapper = styled.div`
  font-size: ${rem(10)};
  line-height: ${rem(12)};
  font-weight: bold;

  ${({ theme }) => theme.media('xs')} {
    font-size: ${rem(8)};
    line-height: ${rem(9)};
  }
`;

const SkvelkoBottomText = styled.div`
  text-transform: uppercase;
  font-weight: 800;
  font-size: ${rem(10)};
  line-height: ${rem(12)};
  margin-top: ${rem(1)};

  ${({ theme }) => theme.media('xs')} {
    font-size: ${rem(9)};
    line-height: ${rem(9)};
    margin-top: ${rem(1)};
  }
`;

interface SaleStickerUpsellProductPreviewProps {
  product: any;
  enableGoodPrice: boolean;
}

const SaleStickerUpsellProductPreview = (
  props: SaleStickerUpsellProductPreviewProps,
) => {
  const { product, enableGoodPrice } = props;

  const isSkvelko = itemIsSkvelko(product);
  return (
    <Wrapper>
      {isSkvelko && enableGoodPrice ? (
        <SkvelkoTextWrapper>
          {' '}
          <SvelkoTopTextWrapper>
            {' '}
            <div>{__('len')}</div> <div>{__('v eshope')}:</div>{' '}
          </SvelkoTopTextWrapper>{' '}
          <SkvelkoBottomText> {__('DOBRÁ CENA')} </SkvelkoBottomText>{' '}
        </SkvelkoTextWrapper>
      ) : (
        <NotSkvelkoTextWrapper> {__('AKCIA')} </NotSkvelkoTextWrapper>
      )}
    </Wrapper>
  );
};

export default SaleStickerUpsellProductPreview;
